import styled from 'styled-components';
import { device } from '../HelperStyle';

export const AboutSectionContainer = styled.div`
  text-align: center;
`;

export const AboutGridContainer = styled.div`
  font-size: 30px;
  margin-right: 30px;
  margin-left: 30px;

  width: 600px;
  min-height: 450px;
  
  @media ${device.tablet} {
    margin: 0 auto;
    margin-top: 30px;
    width: 425px;
  }

  @media ${device.mobileL} {
    margin: 0 auto;
    margin-top: 30px;
    min-width: 300px;
  }
`;

export const SkillDescriptionDiv = styled.p`
  display: none;
`;

/**
 * Main skill icon div
 * Handles the animation for the skill icons + the query that appears above
 * Sets all changing styles including changes in opacity on hover
 */
export const SkillIconDiv = styled.div`
  color: white;
  height: 50px;
  width: 50px;
  padding: 20px 20px 20px 20px;
  position: relative;
  opacity: ${(props) => props.hoveredOpacity};
  transition: 0.4s all ease-in-out;

  &:hover {
    color: ${(props) => props.skillColor};
    transform: scale(1.2);

    // increase transition to make it smoother when hovering (not as slow)
    transition: 0.2s all ease-in-out;
    
    // Main description that shows on hover
    ${SkillDescriptionDiv} {
      display: block;
      width: 80px;
      bottom: 75%;
      left: 50%;
      margin-left: -43px; /* Use half of the width (120/2 = 60), to center the tooltip */
      color: white;

      background-color: #515151;
      text-align: center;
      padding: 3px;
      padding-bottom: 4px;
      padding-top: 4px;

      border-radius: 2px;

      position: absolute;
      z-index: 1;
      
      &:after {
        content: " ";
        position: absolute;
        top: 100%; /* At the bottom of the tooltip */
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #515151 transparent transparent transparent;
      }

      // prevent the user from interactive with the div
      // allows the user to select something that this div might be covering
      &:hover {
        cursor: default;
        pointer-events: none;
      }
    }
  }
`;